import { http } from "@/http/axios.js";

// 获取售后状态信息
export function getAfterSaleStatusInfoAPI(params) {
  return http({
    url: "/admin/afterSaleOrder/afterSaleStatus/info",
    method: "get",
    params,
  });
}

// 更新售后状态
export function updateAfterSaleStatusAPI(data) {
  return http({
    url: "/admin/afterSaleOrder/afterSaleStatus/edit",
    method: "post",
    data,
  });
}
